import { correspondentTypes } from '../../constants/correspondent';

export const flattenArrayConciliation = (array: any[]): any[] => {
  const summaryData = array.map((item) => {
    return {
      ...item,
      transaction_cashin: {
        transaction_name: item.correspondent[0].transaction_type,
        correspondent_total: item.correspondent[0].amount_correspondent,
        correspondent_amount: item.correspondent[0].total_correspondent,
        bank_amount: item.bank[0].amount_bank,
        bank_total: item.bank[0].total_bank,
      },
      transaction_cashout: {
        transaction_name: item.correspondent[1].transaction_type,
        correspondent_total: item.correspondent[1].amount_correspondent,
        correspondent_amount: item.correspondent[1].total_correspondent,
        bank_amount: item.bank[1].amount_bank,
        bank_total: item.bank[1].total_bank,
      },
    };
  });
  return summaryData;
};

export const isSmallCorrespondent = (correspondentType: string): boolean =>
  correspondentType === correspondentTypes.smallCorrespondentYOLO;
